/**
 * LA BELLA SCELTA — Social proof: carousel recensioni e selettore profumo.
 * Nessuna dipendenza esterna. Nessun autoplay.
 */
(function () {
  "use strict";

  /* ---------------- Carousel recensioni ---------------- */
  function initCarousel(root) {
    var track = root.querySelector("[data-carousel-track]");
    var prev = root.querySelector("[data-carousel-prev]");
    var next = root.querySelector("[data-carousel-next]");
    var dots = root.querySelector("[data-carousel-dots]");
    if (!track || !prev || !next || !dots) return;
    var ticking = false;

    function pages() {
      return Math.max(1, Math.ceil((track.scrollWidth - 2) / track.clientWidth));
    }

    function goTo(index) {
      track.scrollTo({ left: index * track.clientWidth, behavior: "smooth" });
    }

    function update() {
      var n = dots.children.length;
      var idx = Math.round(track.scrollLeft / track.clientWidth);
      for (var i = 0; i < n; i++) {
        dots.children[i].classList.toggle("is-active", i === idx);
      }
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }

    function build() {
      var n = pages();
      dots.innerHTML = "";
      root.classList.toggle("is-static", n <= 1);
      for (var i = 0; i < n; i++) {
        (function (index) {
          var b = document.createElement("button");
          b.type = "button";
          b.className = "proof-dot";
          b.setAttribute("aria-label", "Vai alla pagina " + (index + 1));
          b.addEventListener("click", function () { goTo(index); });
          dots.appendChild(b);
        })(i);
      }
      update();
    }

    prev.addEventListener("click", function () {
      track.scrollBy({ left: -track.clientWidth, behavior: "smooth" });
    });
    next.addEventListener("click", function () {
      track.scrollBy({ left: track.clientWidth, behavior: "smooth" });
    });
    track.addEventListener("scroll", function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { update(); ticking = false; });
    });
    track.addEventListener("keydown", function (e) {
      if (e.key === "ArrowRight") { e.preventDefault(); next.click(); }
      if (e.key === "ArrowLeft") { e.preventDefault(); prev.click(); }
    });
    window.addEventListener("resize", build);
    build();
  }

  /* ---------------- Selettore "Dicci che profumo ami" ---------------- */
  function initQuiz(root) {
    var dataEl = root.querySelector("[data-quiz-data]");
    var msg = root.querySelector("[data-quiz-msg]");
    var grid = root.querySelector("[data-quiz-grid]");
    var all = root.querySelector(".quiz-all");
    if (!dataEl || !msg || !grid) return;

    var products = [];
    try { products = JSON.parse(dataEl.textContent); } catch (e) { products = []; }
    var state = {};

    function tagsOf(p) {
      return (p.g || []).map(function (t) { return String(t).toLowerCase(); });
    }

    function render() {
      var groups = Object.keys(state);
      grid.innerHTML = "";
      if (all) all.style.display = "none";

      if (!groups.length) {
        msg.textContent = msg.getAttribute("data-msg-start");
        return;
      }

      var matches = products.filter(function (p) {
        var tags = tagsOf(p);
        return groups.every(function (g) {
          return state[g].some(function (t) { return tags.indexOf(t) !== -1; });
        });
      });

      if (!matches.length) {
        msg.textContent = msg.getAttribute("data-msg-none");
        if (all) all.style.display = "";
        return;
      }

      msg.textContent = msg.getAttribute("data-msg-found");
      matches.forEach(function (p) {
        var a = document.createElement("a");
        a.className = "quiz-card";
        a.href = p.u;
        if (p.i) {
          var img = document.createElement("img");
          img.src = p.i;
          img.alt = p.t;
          img.loading = "lazy";
          a.appendChild(img);
        }
        var name = document.createElement("span");
        name.className = "quiz-card__name";
        name.textContent = p.t;
        var price = document.createElement("span");
        price.className = "quiz-card__price";
        price.textContent = p.p;
        a.appendChild(name);
        a.appendChild(price);
        grid.appendChild(a);
      });
    }

    root.querySelectorAll("[data-quiz-chip]").forEach(function (chip) {
      chip.addEventListener("click", function () {
        var group = chip.getAttribute("data-group");
        var wasActive = chip.classList.contains("is-active");
        root.querySelectorAll('[data-quiz-chip][data-group="' + group + '"]').forEach(function (c) {
          c.classList.remove("is-active");
          c.setAttribute("aria-pressed", "false");
        });
        if (wasActive) {
          delete state[group];
        } else {
          chip.classList.add("is-active");
          chip.setAttribute("aria-pressed", "true");
          state[group] = (chip.getAttribute("data-tags") || "")
            .split(",")
            .map(function (t) { return t.trim().toLowerCase(); })
            .filter(Boolean);
        }
        render();
      });
    });
    render();
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-carousel]").forEach(initCarousel);
    document.querySelectorAll("[data-quiz]").forEach(initQuiz);
  });
})();
